import React, { useState, useEffect } from "react";
import "./TopicFrame.css";
import { Link } from "react-router-dom";
import topicsData from "../../assets/json/themenBeschreibungen.json";

const TopicFrame = ({ entryNumber, topicType, Title, children }) => {
  const [topic, setTopic] = useState(null);

  useEffect(() => {
    if (Title) {
      setTopic({ title: Title });
    } else if (entryNumber !== undefined && topicType) {
      const data = topicType === "signalTheorie" ? topicsData.signalTheorie : topicsData.bildverarbeitung;
      const entry = data[entryNumber];
      setTopic(entry);
    }
  }, [entryNumber, topicType, Title]);

  const formatLink = (index) => {
    return String(index + 1).padStart(2, "0");
  };

  const getLinks = (entryNumber, topicType) => {
    const getTopicLinks = (prefix, totalEntries, entryNumber) => {
      if (entryNumber === 0) {
        return { link1: `/${prefix}/15`, link2: `/${prefix}/02` };
      } else if (entryNumber === totalEntries - 1) {
        return { link1: `/${prefix}/${formatLink(totalEntries - 2)}`, link2: `/${prefix}/01` };
      } else {
        return {
          link1: `/${prefix}/${formatLink(entryNumber - 1)}`,
          link2: `/${prefix}/${formatLink(entryNumber + 1)}`,
        };
      }
    };

    if (topicType === "signalTheorie") {
      const totalEntries = topicsData.signalTheorie.length;
      return getTopicLinks("siga", totalEntries, entryNumber);
    } else if (topicType === "bildverarbeitung") {
      const totalEntries = topicsData.bildverarbeitung.length;
      return getTopicLinks("bv", totalEntries, entryNumber);
    }

    return { link1: "", link2: "" };
  };

  const { link1, link2 } = getLinks(entryNumber, topicType);

  return (
    <>
      <div className="topic">
        <div className="topicBorder">
          <div className="topicFrame">
            {link1 ? <Link to={link1}>◀</Link> : <div></div>}
            <p className="title">{topic?.title}</p>
            {link2 ? <Link to={link2}>▶</Link> : <div></div>}
          </div>
          {topic?.description && <div className="pageDescription">{topic.description}</div>}
        </div>
        <div className="topicContent">{children}</div>
      </div>
    </>
  );
};

export default TopicFrame;
